import { useEffect, useState } from 'react'
import styles from './CommentBox.module.scss'

/** @param {import('./CommentBox.types').CommentBoxProps} props */
export function CommentBox({ comment, placeholder, onChange, maxCharacterCount = 2000 }) {
  const [value, setValue] = useState(comment)

  useEffect(() => {
    setValue(comment)
  }, [comment])

  /** @type {React.ChangeEventHandler<HTMLTextAreaElement>} */
  const handleChange = ({ target: { value } }) => {
    if (!isValidComment(value, maxCharacterCount)) return
    setValue(value)
    onChange(value)
  }

  return (
    <div className={styles['comment-box']}>
      <textarea rows={3} placeholder={placeholder} onChange={handleChange} value={value} />
      <div className={styles['character-count']}>
        <p>
          {value?.length || 0}/{maxCharacterCount}
        </p>
      </div>
    </div>
  )
}

/**
 * @param {string} comment
 * @param {number} limit
 */
const isValidComment = (comment, limit) => (comment?.length || 0) <= limit

export default CommentBox
